import React from 'react';
import { Helmet } from 'react-helmet';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { I18nextProvider } from "react-i18next";
import i18n from 'i18next';


import languageConfig from './languageConfig';

let savedLanguage = localStorage.getItem('language');

if( !savedLanguage ) {
  //const userLang = navigator.language || navigator.browserLanguage;
  const lang = 'es';
  const current_language = (lang !== 'es' && lang !== 'en') ? 'es' : lang;
  localStorage.setItem('language', current_language);
  savedLanguage = localStorage.getItem('language');
} else {
  const current_language = (savedLanguage !== 'es' && savedLanguage !== 'en') ? 'es' : savedLanguage;
  localStorage.setItem('language', current_language);
  savedLanguage = localStorage.getItem('language');
}

i18n.init({
  interpolation: { especValue: false },
  lng: savedLanguage,
  resources: languageConfig
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Helmet>
      {/* <meta http-equiv="Content-Security-Policy" content="script-src 'self' https://www.google-analytics.com; script-src-elem 'self'" />*/}
      <title>Sitio oficial de Ricardo Salinas</title>
      {/* 
      <meta name="description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
      <meta property="og:title" content="Sitio oficial de Ricardo Salinas" />
      <meta property="og:description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.ricardosalinas.com/static/media/fotoRS.f8a63f65b159e735a517.png" />
      <meta property="og:url" content="https://www.ricardosalinas.com/" />*/}
    </Helmet>
    <I18nextProvider i18n={ i18n }>
      <App />
    </I18nextProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
